"use client";

import { usePathname } from "next/navigation";
// import Navbar from "@/app/components/Navbar";
// import Footer from "@/app/components/Footer";
import { ADMIN_BASE_PATH } from "@/app/common/constants";
import RouteContentTransition from "@/components/ui/RouteContentTransition";

interface LayoutContentProps {
  children: React.ReactNode;
}

export default function LayoutContent({ children }: LayoutContentProps) {
  const pathname = usePathname();
  
  // Check if we're in the manage-portal section
  const isManagePortal = pathname.startsWith(ADMIN_BASE_PATH);
  
  // For manage-portal routes, don't show navbar and footer
  if (isManagePortal) {
    return <>{children}</>;
  }
  
  // For regular routes, show the full layout with navbar and footer
  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* <Navbar /> */}
      <main className="flex-1 flex flex-col">
        <RouteContentTransition>{children}</RouteContentTransition>
      </main>
      {/* <Footer /> */}
    </div>
  );
}
